export const routes = {
  home: { pathname: 'qui-suis-je', label: 'Qui suis-je ?', key: 'accueil' },
  prestations: { pathname: 'prestations', label: 'Prestations', key: 'prestations' },
  tarifs: { pathname: 'tarifs', label: 'Tarifs', key: 'tarifs' },
  contact: { pathname: 'contact', label: 'Contact', key: 'contact' },
};
